const photos = [
	{
	   image: '/images/img11.jpg',
	   title: 'Wanted Off The Wall',
	   description: 'Retro military movie inspired design done for practice.'
	},
	{
	   image:
	     '/images/img1.jpg',
	   title: 'Coffee Maker',
	   description: 'Retro military movie inspired design for Thesis Group Avatar and profile page.',
	},
	{
	   image:
	     '/images/img2.jpg',
	   title: 'Programmer 1',
	   description: 'Retro military movie inspired design for Thesis Group Avatar and profile page.',
	 },
	 {
	   image:
	     '/images/img3.jpg',
	   title: 'Programmer 2',
	   description: 'Retro military movie inspired design for Thesis Group Avatar and profile page.',
	 },
	 {
	   image:
	     '/images/img4.jpg',
	   title: 'Researcher',
	   description: 'Retro military movie inspired design for Thesis Group Avatar and profile page.',
	 },
	 {
	   image:
	     '/images/img5.jpg',
	   title: 'Pares King',
	   description: 'Retro military movie inspired design for Thesis Group Avatar and profile page.',
	 },
	 {
	   image:
	     '/images/img7.jpg',
	   title: 'Hair Brush 1',
	   description: 'Watercolor hair brush effect done for practice for university activity.',
	 },
	 {
	   image:
	     '/images/img6.jpg',
	   title: 'Hair Brush 2',
	   description: 'Watercolor hair brush effect done for practice for university activity.',
	 },
	 {
	   image:
	     '/images/img8.jpg',
	   title: 'Hair Brush 3',
	   description: 'Watercolor hair brush effect done for practice for university activity.',
	 },
	 {
	   image:
	     '/images/img9.jpg',
	   title: 'Hair Brush 4',
	   description: 'Watercolor hair brush effect done for practice for university activity.',
	 },
	 {
	   image:
	     '/images/img10.jpg',
	   title: 'Hair Brush 5',
	   description: 'Watercolor hair brush effect done for practice for university activity.',
	 },
	 {
	   image:
	     '/images/img12.jpg',
	   title: 'Zuitt Blue Avatar',
	   description: 'Zuitt Company Avatar recollored',
	 },
	 {
	   image:
	     '/images/img13.jpg',
	   title: 'Zuitt Avatar',
	   description: 'Zuitt Company Avatar original.',
	 },
	 {
	   image:
	     '/images/img15.jpg',
	   title: 'Apocalyptic Scene',
	   description: 'Image processing project in college for using blending on cropped layers on a new image.',
	 },
	 {
	   image:
	     '/images/img14.jpg',
	   title: 'Comic Stamp',
	   description: 'Image processing project in college for using pen tool in Adobe Illustrator.',
	 },
	 {
	   image:
	     '/images/img16.jpg',
	   title: 'Be One Of Us',
	   description: 'Image processing project in college to advertise IT Department and IT majors in the university.',
	 },
	 {
	   image:
	     '/images/img17.jpg',
	   title: 'Wings in Hell',
	   description: 'Image processing project in college for using blending on cropped layers and smoke brushes on a new image.',
	 },
	 {
	   image:
	     '/images/img18.jpg',
	   title: 'Blue Scenery',
	   description: 'Image processing project in using saturation, blending, color overlays, and lighting.',
	 },
	 {
	   image:
	     '/images/img20.jpg',
	   title: 'Comic Book Grain',
	   description: 'Image processing project in using photoshop filters.',
	 },
	 {
	   image:
	     '/images/img19.jpg',
	   title: 'Deconstruction',
	   description: 'Image processing project dispersion effect by using blending and particle brushes.',
	 },
	 {
	   image:
	     '/images/img21.png',
	   title: 'Jobs Abroad Available',
	   description: 'Example marketing poster for a recruitment agency done for a technical exam.',
	 }
];

export default photos;